import styled from '@emotion/styled'

// The step heading. Only the total is bold (rendered via <strong>), matching the
// SSI/retirement-age heading treatment.
export const Heading = styled.h1`
  width: 90%;
  font-weight: normal;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 30px;
  line-height: 1.3;
  text-align: center;
  max-width: 760px;
  margin: 0;
  color: ${p => p.theme.mediumGray};

  strong {
    font-weight: bold;
    color: ${p => p.theme.darkestGray};
  }

  @media (max-width: 600px) {
    font-size: 24px;
  }
`

export const TableWrap = styled.div`
  width: 100%;
  max-width: 820px;
  margin-top: 70px;

  @media (max-width: 600px) {
    margin-top: 30px;
  }
`
